module.exports = __webpack_public_path__ + "img/Default.8941136d.jpg";